import { useDashboardSurveyList } from "./useDashboardSurveyList";
import { FILTER_STATUS_LIST } from "./dashboard-survey-list.constants";
import { capitalize, debounce } from "lodash";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Search } from "lucide-react";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

const DashboardSurveyFilter = () => {
  const { activeStatus, onFilterSelected, onTitleSearch, onUserFilterSelected, showAllUsers } = useDashboardSurveyList();
  const [searchParams] = useSearchParams();
  const initialSearchValue = searchParams.get('title') || "";
  const [searchValue, setSearchValue] = useState(initialSearchValue);

  const debouncedSearch = debounce((value: string) => {
    onTitleSearch(value);
  }, 300);

  const renderFilterOption = (status: string, isActive: boolean) => {
    return (
      <Button
        size='med'
        className={isActive ? '' : 'bg-gray-201 hover:bg-blue-500 hover:text-white hover:opacity-75'}
        variant={isActive ? 'primary' : 'gray'}
        onClick={() => onFilterSelected(status)}
        key={status}
      >
        {capitalize(status)}
      </Button>
    );
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchValue(newValue);
    debouncedSearch(newValue);
  };

  return (
    <div className="flex flex-col flex-wrap md:flex-row sm:justify-between items-center gap-5">
      <div className="flex flex-row gap-2 justify-end">
        {renderFilterOption('All', activeStatus === undefined)}
        {FILTER_STATUS_LIST.map((status) => renderFilterOption(status, activeStatus === status))}
      </div>
      <div className="h-8 border-l-1 border-black/10 -mx-1 hidden md:block" />
      <div className="flex flex-row gap-2">
        <Button
          size='med'
          variant={!showAllUsers ? 'primary' : 'gray'}
          className={!showAllUsers ? 'bg-green-1000' : 'bg-gray-201 hover:bg-green-1000 hover:text-white hover:opacity-75'}
          onClick={() => onUserFilterSelected(false)}
        >
          Mine
        </Button>
        <Button
          size='med'
          variant={showAllUsers ? 'primary' : 'gray'}
          className={showAllUsers ? 'bg-green-1000' : 'bg-gray-201 hover:bg-green-1000 hover:text-white hover:opacity-75'}
          onClick={() => onUserFilterSelected(true)}
        >
          All
        </Button>
      </div>
      <div className="relative flex-1 md:order-first w-full">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        <Input
          type="text"
          placeholder="Search"
          value={searchValue}
          onChange={handleSearchChange}
          className="pl-10 bg-white rounded-full placeholder:text-black/75 h-10 border-none shadow-none focus:outline-none focus:ring-0 focus:border-gray-300 focus-visible:outline-none focus:ring-0 focus:ring-transparent"
        />
      </div>
      <div className="h-8 border-l-1 border-black/10 -mx-1 hidden lg:block" />
    </div>
  );
};

export default DashboardSurveyFilter;
